import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { isLocal } from "@/utils/helpers/formatters"
import { baseQueryWithReauth } from "@/store/apis/baseQueryWithReauth"

// stick to one createApi for managing cache buckets for cross api invalidations
// https://stackoverflow.com/questions/69243083/rtk-query-invalidate-cache-of-an-api-service-from-another-api-service
export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  // we will inject endpoints per context
  endpoints: () => ({}),
  tagTypes: [
    "Member",
    "Switches",
    "CommsPrefs",
    "MemberDetails",
    "UserProfile",
    "UpdatePhone",
    "ApplicationData",
    "StoredDocuments",
    "IlbaPreference",
    "AccountBalance",
    "BankAccounts",
  ],
  keepUnusedDataFor: 60,
})

const query = new URLSearchParams(window.location.search)
const mockData = query.get("mockData")

// Enables mock data by using locally captured responses
// instead of waiting for api responses during dev
export const mockDataEnabled =
  isLocal() &&
  query.has("mockData") &&
  (mockData?.length ? mockData.split(",") : true)

export const mockSessionEnabled = isLocal() && query.has("mockSession")

// Add ?mockContent to the URL to also mock Matrix body content (content.ts).
// Off by default so mock mode works without needing the local content fixture.
export const mockContentEnabled = isLocal() && query.has("mockContent")

export default apiSlice.reducer
